<script>
    import DashboardSlideshow from "../components/dashboard_slideshow/DashboardSlideshow.svelte";
</script>

<div style="height: 500px">
    <DashboardSlideshow />
</div>
